

<template>
  <div class="mobileBulletFrameWarp" :style="show?'opacity:.96' : ''">
    <div class="bulletFrameWarpLeft">
      <div class="pLogWarp">
        <img @click="openLink" :src="pInfo.avatar" alt="">
      </div>
      <div class="back" @click="close">
        <img src="../../assets/image/mobile/m_close.png" alt="">
      </div>
    </div>
    <div class="bulletFrameWarpRight">
      <div class="title fOH">{{pInfo.title || 'pInfo昵称'}} </div>
      <div class="content fOM" v-html="pInfo.desc || ''">

      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'MobileBulletFrame',
  props:{
    pInfo:{
      type:Object,
      default(){
        return {}
      }
    },
  },
  created() {
    setTimeout(r=>{
      this.show = true
    },100)
  },
  data(){
    return {
      show:false,
      content:`<p style="padding-left:0.8rem;rtner leading healthcare investment at HongShan Capital (previously Sequoia China)&nbsp;</p></li><li><p>Managing Partner and Founder of Everbright Healthcare Fund</p></li><li><p>Co-founder of ShangPharma (parent company of ChemPartner 300149.SZ) , a startup CRO company listed on the NYSE in 2010</p></li><li><p>Management and research experience at Ligand Pharma in San Diego and DuPont both in the US and China&nbsp;</p></li><li><p>Selective Investments include OBiO (688238.SH), MediTrust Health, BGI (300676 SZ), Betta Pharma (300558 SZ), Zai Lab (ZLAB, Nasdaq), Baheal Pharma (301015.SZ), Bright Eye Hospital (301239.SZ) and Yuwell (002223.SZ)</p></li></ul><p><br/></p><p style="padding-left:0.8rem;">Experience:</p><ul class=" list-paddingleft-2" style="list-style-type: disc;"><li><p>Founded BioTrack Capital in 2017</p></li><li><p>Partner leading healthcare investment at HongShan Capital (previously Sequoia China)&nbsp;</p></li><li><p>Managing Partner and Founder of Everbright Healthcare Fund</p></li><li><p>Co-founder of ShangPharma (parent company of ChemPartner 300149.SZ) , a startup CRO company listed on the NYSE in 2010</p></li><li><p>Management and research experience at Ligand Pharma in San Diego and DuPont both in the US and China&nbsp;</p></li><li><p>Selective Investments include OBiO (688238.SH), MediTrust Health, BGI (300676 SZ), Betta Pharma (300558 SZ), Zai Lab (ZLAB, Nasdaq), Baheal Pharma (301015.SZ), Bright Eye Hospital (301239.SZ) and Yuwell (002223.SZ)</p></li></ul><p><br/></p> `
    }
  },
  methods:{
    openLink() {
      if(this.pInfo.c_url){
        try {
          window.open(this.pInfo.c_url)
        }catch (e){
          window.location.href = this.pInfo.c_url
        }
      }
    },
    close(){
      this.show = false
      this.$emit('close')
    }
  }
}
</script>
<style scoped lang="scss">
  .mobileBulletFrameWarp{
    position: fixed;
    top: 4rem;
    left: 50%;
    transition: .5s;
    transform: translateX(-50%);
    z-index: 100;
    background: red;
    height: calc(100% - 4rem);
    width: calc(100% - 1.8rem);
    box-sizing: border-box;
    background: linear-gradient(-20deg, #185FCB 0%, #74B5D4 100%);
    border-radius: 10px;
    .bulletFrameWarpRight{
      padding-top: 1rem;
      margin-right: 1rem;
      margin-left: 1rem;
      box-sizing: border-box;
      flex: 1;
      display: flex;
      justify-content: center;
      flex-direction: column;
      overflow: hidden;
      height: 100%;
      .title{
        color: #fff;
        padding-bottom: 1rem;
        border-bottom: .07rem solid rgba(255,255,255,.7);
      }
      .content{
        margin-top: 1rem;
        flex: 1;
        overflow: hidden;
        overflow-y: auto;
        color: #fff;
        font-size: .95rem;
        line-height: 1.8rem;
      }
    }
    .bulletFrameWarpLeft{
      margin-top: 1rem;
      margin-left: 1rem;
      box-sizing: border-box;
      position: relative;
      .back{
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        position: absolute;
        top: 0;
        right: 1.2rem;
        img{
          width: 1rem;
        }
        .bText{
          color: #fff;
          font-size: .9rem;
          margin-left: .5rem;
        }
      }
      .pLogWarp{
        img{
          width: 50%;
        }
      }
    }
  }
</style>
